module.exports = __webpack_public_path__ + "static/img/ahrm.5f4a986.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/ahrm.png
// module id = 9iEF
// module chunks = 0